import * as actions from "../actionTypes";
import {
  GET_ENROLLMENTS,
  ADD_ENROLLMENT,
  UPDATE_ENROLLMENT,
  DELETE_ENROLLMENT,
} from "../api";
import client from "../apolloClient";
import { setAttendances } from "./attendanceActions.js";
import { setAttendanceModified } from "./loadingActions.js";

export const deleteEnrollment =
  (enrollment_id) => async (dispatch, getState) => {
    try {
      // Perform the GraphQL mutation to delete the enrollment
      await client.mutate({
        mutation: DELETE_ENROLLMENT,
        variables: { input: enrollment_id },
      });

      // Dispatch the action to remove the enrollment from the state
      const action = {
        type: actions.DELETE_ENROLLMENT,
        payload: enrollment_id,
      };
      dispatch(action);

      // Get the current state
      const state = getState();

      // Find the deleted enrollment
      const enrollment = state.enrollments.find(
        (en) => en._id === enrollment_id
      );

      if (enrollment) {
        // Filter attendances related to the enrollment
        const attendances = state.attendances.filter(
          (at) => at.enrollment._id === enrollment_id
        );

        // Filter assignments related to the subject instance of the enrollment
        const assignmentsIds = state.assignments
          .filter((as) => as.subjectInstance._id === enrollment.subjectInstance)
          .map((as) => as._id);

        // Filter grades related to the student and assignments of the enrollment
        const grades = state.grades.filter(
          (gr) =>
            gr.student._id === enrollment.student._id &&
            assignmentsIds.includes(gr.assignment)
        );

        // Dispatch actions to remove the attendances from the state
        attendances.forEach((attendance) => {
          const action5 = {
            type: actions.DELETE_ATTENDANCE,
            payload: attendance._id,
          };
          dispatch(action5);
        });

        // Dispatch actions to remove the grades from the state
        grades.forEach((grade) => {
          const action3 = { type: actions.DELETE_GRADE, payload: grade._id };
          dispatch(action3);
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

export const setEnrollments = (enrollments) => async (dispatch) => {
  try {
    let arrayOfAttendances = [];
    enrollments.forEach((enrollment) => {
      if (enrollment.attendances && enrollment.attendances.length > 0) {
        enrollment.attendances.forEach((attendance) => {
          const enrichedAttendance = {
            ...attendance,
            enrollment: {
              ...attendance.enrollment,
              student: enrollment.student,
              subjectInstance: enrollment.subjectInstance,
              status: enrollment.status,
            },
          };
          arrayOfAttendances.push(enrichedAttendance);
        });
      }
    });
    if (arrayOfAttendances.length > 0) {
      await dispatch(setAttendances(arrayOfAttendances));
    } else {
      await dispatch(setAttendanceModified(false));
    }

    const action = { type: actions.SET_ENROLLMENTS, payload: enrollments };
    dispatch(action);
  } catch (error) {
    console.log(error);
  }
};

export const addEnrollment = (enrollment) => async (dispatch, getState) => {
  try {
    const { data } = await client.mutate({
      mutation: ADD_ENROLLMENT,
      variables: { input: enrollment },
    });
    const savedEnrollment = await data.createEnrollment;
    const action = { type: actions.ADD_ENROLLMENT, payload: savedEnrollment };
    dispatch(action);
    const state = getState();
    if (!state.students.find((s) => s._id === savedEnrollment.student._id)) {
      const studentToAddToActives = {
        ...savedEnrollment.student,
        enrollments: [savedEnrollment],
      };
      const studentAction = {
        type: actions.ADD_STUDENT,
        payload: studentToAddToActives,
      };
      dispatch(studentAction);
    } else {
      const studentToUpdate = savedEnrollment.student;
      const prevEnrollmentsOfStudent = state.students.find(
        (s) => s._id === savedEnrollment.student._id
      ).enrollments;
      const updatedStudent = {
        ...studentToUpdate,
        enrollments: [...prevEnrollmentsOfStudent, savedEnrollment],
      };
      const studentAction = {
        type: actions.UPDATE_STUDENT,
        payload: updatedStudent,
      };
      dispatch(studentAction);
    }
  } catch (error) {
    console.log(error);
  }
};

export const updateEnrollment = (enrollment) => async (dispatch) => {
  try {
    await client.cache.reset();
    const { data } = await client.mutate({
      mutation: UPDATE_ENROLLMENT,
      variables: { input: enrollment },
      fetchPolicy: "no-cache",
    });
    const savedEnrollment = data.updateEnrollment;
    const action = {
      type: actions.UPDATE_ENROLLMENT,
      payload: savedEnrollment,
    };
    dispatch(action);
  } catch (error) {
    console.log(error);
  }
};
